<template>
  <div>

    <el-card shadow="never"
             class="aui-card--fill">
      <el-form :model="taskForm"
               ref="taskForm">
        <div class="location-layout">
          <div class="opten-title">
            <em class="el-icon-caret-right"></em>{{ $t('activiti.taskInformation') }}</div>
          <el-row class="row-mar-l">
            <el-col :span="6">
              <el-form-item :label="$t('activiti.missionName')">
                <el-input v-model="taskForm.taskName"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('activiti.sponsor')">
                <el-input v-model="taskForm.processStartUserName"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    v-if="this.approval + '' === '0'">
              <el-form-item :label="$t('activiti.taskApprovalTime')">
                <el-input v-model="taskForm.endTime"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    v-else>
              <el-form-item :label="$t('activiti.startingTime')">
                <el-input v-model="taskForm.variables.processStartDate"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('activiti.approver')">
                <el-input v-model="taskForm.curAssigneeName"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="6"
                    v-if="this.approval + '' === '0'">
              <el-form-item :label="$t('activiti.taskArrivalTime')">
                <el-input v-model="taskForm.startTime"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    v-else>
              <el-form-item :label="$t('activiti.taskArrivalTime')">
                <el-input v-model="taskForm.createTime"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-card>

    <el-card shadow="never"
             class="aui-card--fill">
      <div class="location-layout">
        <div class="opten-title">
          <em class="el-icon-caret-right"></em>{{$t('activiti.businessInformation')}}</div>
        <router-view ref="child"
                     :createDate="taskForm.variables.processStartDate" />
        <div class="task-card-factory-desc" v-if="factoryDesc&&(type === 'transfer' || type === 'register')">
          <p class="task-card-factory-desc-title">{{ $t('assessment.factoryEvaluation')  + '：' }}</p>
          <div>
            <el-input style="width: 100%; margin-top: 20px; position: relative;"
              prop="textarea"
              type="textarea"
              disabled
              :rows="6"
              :placeholder="$t('assessment.factoryEvaluation')"
              maxlength="500"
              resize="none"
              show-word-limit
              v-model="factoryDesc"></el-input>
          </div>
          <p class="task-card-factory-desc-title task-card-factory-desc-title2" @click="downloadFile" v-if="factoryFile">{{ $t('assessment.factoryFileTitle') }}</p>
        </div>
      </div>
    </el-card>

    <el-card shadow="never"
             class="aui-card--fill"
             v-if="approval === 1 || approval === '1'">
      <!-- 离职审批：处理 确认 PC端注册第一步：处理 提交 撤回 其他：审批 同意 拒绝 -->
      <div class="location-layout"
           v-if="type === 'dimission'">
        <div class="opten-title">
          <em class="el-icon-caret-right"></em>{{ $t('activiti.dealWith') }}</div>
        <el-button style="width: 50px; margin-top: 10px"
                   class="M-search"
                   @click="approved(10)"
                   type="primary"
                   :loading="loading"
                   :disabled="preventClick">{{ $t('activiti.confirm') }}
        </el-button>
        <el-input style="width: 100%; margin-top: 20px; position: relative;"
                  prop="textarea"
                  type="textarea"
                  :rows="4"
                  :placeholder="$t('activiti.pleaseEnterApprovalOpinion')"
                  maxlength="200"
                  show-word-limit
                  v-model="textarea">
        </el-input>
      </div>
      <div class="location-layout"
           v-else-if="pcRegister === '1'||pcRegister === '2'">
        <div class="opten-title">
          <em class="el-icon-caret-right"></em>{{ $t('activiti.dealWith') }}</div>
        <el-button style="width: 50px; margin-top: 10px"
                   class="M-search"
                   @click="approved(10)"
                   type="primary"
                   :loading="loading">{{ $t('activiti.submit') }}
        </el-button>
        <el-button style="width: 50px; margin-top: 10px"
                   class="M-search disagree"
                   @click="withdraw()"
                   :loading="loading">{{ $t('activiti.withdraw') }}
        </el-button>
      </div>
      <div class="location-layout"
           v-else>
        <div class="opten-title">
          <em class="el-icon-caret-right"></em>{{ $t('activiti.approval') }}</div>
        <el-button style="width: 50px; margin-top: 10px"
                   class="M-search"
                   @click="approved(10)"
                   type="primary"
                   :loading="loading"
                   :disabled="preventClick">{{ $t('activiti.agree') }}
        </el-button>
        <el-tooltip class="item"
                    effect="dark"
                    placement="right"
                    :disabled="!isDisable">
          <div slot="content">{{pleaseEnterApproval}}</div>
          <div class="disagreeClass">
            <el-button :disabled='isDisable'
                       style="width: 50px; margin-top: 10px"
                       class="M-search disagree"
                       @click="approved(20)"
                       :loading="loading">{{ $t('activiti.disagree') }}
            </el-button>
          </div>
        </el-tooltip>

        <!-- 20220120 注册流程 转岗流程 进入区域经理审批节点，直接添加固定文字  -->
        <el-checkbox v-if="this.isAreaManagerAudit && (this.type === 'transfer' || this.type === 'register')"
                     :disabled="(this.approval === '0') || (this.approval === 0)"
                     style="margin-left: 10px"
                     :label="$t('activiti.areaManagerConfirmText')"
                     v-model="approvalConfirmChecked">
        </el-checkbox>

        <div v-if="this.isAreaManagerAudit && (this.type === 'transfer' || this.type === 'register') && this.positionNameCn != undefined" style="margin-top: 10px;margin-left: 20px">
          <div style="margin-top: 10px;margin-left: 20px">
            <span>{{ $t('activiti.resume') }}</span>
            <a @click="openResume" class="addPointer">{{ $t('activiti.resumeDetails') }}</a>
          </div>
          <div style="margin-top: 10px;margin-left: 20px">
            <span>{{ $t('activiti.report') }}</span>
            <label><a class="addPointer" @click="expertEvaluationDow">{{fileName}}</a></label>
          </div>
        </div>

        <el-input style="width: 100%; margin-top: 20px; position: relative;"
                  prop="textarea"
                  type="textarea"
                  :rows="4"
                  :placeholder="$t('activiti.pleaseEnterApprovalOpinion')"
                  maxlength="1000"
                  show-word-limit
                  v-model="textarea">
        </el-input>
      </div>
    </el-card>

    <el-card shadow="never"
             class="aui-card--fill">
      <div class="location-layout">
        <div class="opten-title">
          <em class="el-icon-caret-right"></em>{{$t('activiti.approvalHistory')}}</div>
        <el-table :data="processForm"
                  border
                  style="width: 100%;">
          <el-table-column prop="processInstanceName"
                           align="center"
                           :label="$t('activiti.processName')">
          </el-table-column>
          <el-table-column prop="taskName"
                           align="center"
                           :label="$t('activiti.missionName')">
          </el-table-column>
          <el-table-column prop="hisAssigneeName"
                           align="center"
                           :label="$t('activiti.approver')">
          </el-table-column>
          <el-table-column prop="commentStatus"
                           align="center"
                           :label="$t('activiti.approvalStatus')">
          </el-table-column>
          <el-table-column prop="commentValue"
                           align="center"
                           show-overflow-tooltip
                           width="200"
                           :label="$t('activiti.approvalComments')">
          </el-table-column>
          <el-table-column prop="startTime"
                           align="center"
                           width="140"
                           :label="$t('activiti.timeOfArrival')">
          </el-table-column>
          <el-table-column prop="endTime"
                           align="center"
                           width="140"
                           :label="$t('activiti.processingTime')">
          </el-table-column>
        </el-table>
        <el-pagination @size-change="pageSizeChangeHandle"
                       @current-change="pageCurrentChangeHandle"
                       :current-page="page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="limit"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
      <div class="btn-position-up"
           v-if="type === 'dimission'">
        <el-button @click="backPage()">{{ $t('organization.back') }}</el-button>
      </div>
    </el-card>
    <!-- 费用结算dialog -->
    <el-dialog
            class="replaceDialog"
            width="700px"
            v-if="discountDialog"
            :visible.sync="discountDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :append-to-body="true"
            :show-close="true"
            :before-close="cancelForm"
            top="8vh">
      <div class="el-dialog__header_cus" slot="title">
        费用结算
      </div>
      <div>
        <!-- 申请人 -->
        <el-row :gutter="10">
          <el-col :span="24"
                  style="color: rgba(37, 38, 40, 100);
            font-size: 14px;
            text-align: left;
            font-family: PingFangSC-Medium, sans-serif;margin-bottom:24px;">
            申请人： {{userCode}} <span class="tag-reduction" v-if="isDeduction" style="font-size: 12px">减免</span>
          </el-col>
        </el-row>
        <div class="show-msg-container">
          <el-row :gutter="10" style="margin-bottom: 8px">
            <el-col :span="12">
            <el-col :span="8">
              <div class="msg-label" style="float: right">课程费用(元):</div>
            </el-col>
            <el-col :span="10" style="padding-left: 2px; padding-right: 12px">
              <div
                      class="msg-value"
                      style="float: right">
                {{    formatMoney(Number ((dataForm.coursePrice).toFixed(3))) }}
              </div>
              <!-- <div class="msg-value" style="float: right" v-else>
                {{ this.formatMoney(Number(paymenttotalmoney.toFixed(3))) }}
              </div> -->
            </el-col>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="margin-bottom: 8px" v-if="isDeduction">
            <el-col :span="12">
            <div style="text-align: center">
              <el-col :span="8">
                <div class="msg-label" style="float: right">减免金额(元):</div>
              </el-col>
              <el-col :span="10" style="padding-left: 2px; padding-right: 12px">
                <div class="msg-value" style="float: right">
                  {{  formatMoney(Number ((dataForm.coursePrice).toFixed(3)))}}
                </div>
              </el-col>
            </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="margin-bottom: 8px">
            <el-col :span="12">
              <el-col :span="8">
                <div class="msg-label" style="float: right">支付金额(元):</div>
              </el-col>
              <el-col :span="10" style="padding-left: 2px; padding-right: 12px">
                <div style="float: right" class="msg-value">
                  {{ formatMoney(Number ((cousrprice).toFixed(3))) }}
                </div>
              </el-col>
<!--              <div style="float:right"><div style="float:left">支付金额(元):</div><div style="float:left">{{paymenttotalmoney}}</div></div>-->
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
            <el-col :span="8">
              <div class="msg-label" style="float: right">可用金额(元):</div>
            </el-col>
            <el-col :span="10" style="padding-left: 2px; padding-right: 12px">
              <div class="msg-value" style="float: right">
                {{ this.formatMoney(Number ((accountBalances).toFixed(3))) }}
              </div>
            </el-col>
            </el-col>
            <el-col :span="12" v-if="Number(Number(accountBalances)-Number(cousrprice))>=0">
              <el-col :span="24">
                <div class="msg-value msg-spe-value" style="float: right">
                  {{ formatMoney(Number (((accountBalances-cousrprice)).toFixed(3))) }}
                </div>
                <div class="msg-label" style="float: right; margin-right: 5px">
                  付费后可用余额(元):
                </div>
              </el-col>
            </el-col>
          </el-row>
        </div>
      </div>
      <el-row
              justify="space-between"
              style="
          padding-top: 24px;
          margin-top: 16px;
          border-top: 1px dashed rgba(0, 0, 0, 0.1);
        "
      >
        <!--        <el-col :span="4">&nbsp;</el-col>-->
        <el-col :span="10">&nbsp;</el-col>
        <el-col :span="14" style="text-align: right">
          <el-button
                  @click="cancelForm()"
                  :loading="dataListLoading"
          >{{ $t("registe.cancel") }}</el-button
          >
          <el-button
                  :loading="dataListLoading"
                  type="primary"
                  @click="submitForm()"
          >确定</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog
            v-if="dialogVisible1"
            :visible.sync="dialogVisible1"
            :close-on-click-modal="true"
            :modal="true"
            :show-close="true"
            :center="true"
            :append-to-body="true"
            width="990px">
      <el-row>
        <el-col :span="24" style="height: 44px; margin: auto; text-align: center; font-weight: 700; font-size: 14px; color: #409EFF">
          <p>该学员已报名该时段的其他排期，由于时间冲突，操作失败。冲突排期如下：</p>
        </el-col>
      </el-row>
      <br>
      <el-table border :data="errorData" :header-cell-style="{background: '#EBEEF5'}">
        <el-table-column width="141px" label="排期编号" header-align="center" align="center" show-overflow-tooltip prop="offeringNo"></el-table-column>
        <el-table-column width="200px" label="课程名称" header-align="center" align="center" show-overflow-tooltip prop="courseName"></el-table-column>
        <el-table-column width="200px" label="开始时间" header-align="center" align="center" show-overflow-tooltip prop="startDate"></el-table-column>
        <el-table-column width="200px" label="结束时间" header-align="center" align="center" show-overflow-tooltip prop="endDate"></el-table-column>
        <el-table-column width="200px" label="场地" header-align="center" align="center" show-overflow-tooltip prop="siteName"></el-table-column>
      </el-table>
      <br>
      <!-- <span slot="footer" class="dialog-footer">
         <el-button @click="dialogVisible1 = false">取 消</el-button>
         <el-button type="primary" @click="dialogVisible1 = false">确 定</el-button>
       </span>-->
    </el-dialog>
    <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        width="30%">
          <span>此用户手机号与{{ UserNames }}手机号相同是否自动将{{ UserNames }}手机号设置为{{ UsersPhone }}</span>
          <span slot="footer" class="dialog-footer">
          <el-button type="primary" style="width: 50%;margin: 0 !important; border-right: 0.5px solid #000;" size="medium"  @click="click">取消</el-button>
          <el-button type="primary" style="width: 50%;margin: 0 !important; border-left: 0.5px solid #000;" size="medium"  @click="affirmatives">确定</el-button>
    </span>
  </el-dialog>

  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module-activiti'
import AesUtil from "@/utils/aes_utils";
import debounce from 'lodash/debounce'
import VueI18n from '@/i18n'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      affirmative: false,
      UserNames:"",
      UsersPhone:"",
      centerDialogVisible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/act/operate/historyByProcessId',
        activatedIsNeed: false,
        getDataListIsPage: true
      },
      dialogVisible1:false,
      loading: false, // 审批按钮点击进入loading状态
      // 拒绝按钮提示信息
      pleaseEnterApproval: this.$t('activiti.pleaseEnterApproval'),
      textarea: '',
      userId: '',
      approval: 1, // 待办已办 待办1 已办0
      type: '', // 业务类型 transfer转岗 dimission离职 register入职
      isDisable: true,
      dataForm: {},
      processForm: [], // 审批记录
      userRole: 'hradminAudit', // 审批角色 hradminAudit areaAudit
      businessEntrance: '',
      pcRegister: '0', // PC端注册，打回到HR需要显示不同的审批按钮
      dealAll: '', // 所有待办标识位 1为所有待办
      taskForm: {
        variables: {},
        nextFinished: '0'
      }, // 任务信息
      preventClick: false,
      maxDealerCnt: false,
      factoryDesc: '',
      factoryFile: '',
      businessKey: 1,
      taskUserId: '',
      userCode:'',
      isDeduction:false,
      isDealer:'',
      accountBalance:'',
      deduction:'',
      coms:'',
      cousrprice:'',
      accountBalances:'',
      /// 付费后可用余额
      comsh:'',
      cout:'',
      isJoin:'',
      isTrue:'',
      discountDialog:false, //费用结算 dialog
      dataListLoading:false,
      errorData: [],

      // 20220120 确认修改删除部分内容
      // 区域经理审批确认勾选项
      approvalConfirmChecked: false,
      // 评估报告名
      fileName: '',
      // 评测id
      recruitmentId: '',
      // 经销商名
      dealerName: '',
      // 评估职位名
      positionNameCn: '',
      // 当前审批节点为区域经理审批
      isAreaManagerAudit: false
    }
  },
  watch: {
    textarea(val) {
      if (val.trim() === '' || val === undefined || val === null) {
        this.isDisable = true
      } else {
        this.isDisable = false
      }
    }
  },
  computed: {
  },
  activated() {
    this.$nextTick(() => {
      if (this.$route.query.dealAll) {
        this.dealAll = this.$route.query.dealAll
      } else {
        this.dealAll = ''
      }
      if (this.$route.query.userRole) {
        this.userRole = this.$route.query.userRole
      } else {
        this.userRole = ''
      }
      if (this.$route.query.type) {
        this.type = this.$route.query.type // 工作流类型，离职审批没有拒绝
      }
      if (this.$route.query.pcRegister) { // PC注册
        this.pcRegister = this.$route.query.pcRegister
      } else {
        this.pcRegister = '0'
      }
      // 如果不从待办页面进入离职页面，则返回离职列表
      if (this.$route.query.businessEntrance) {
        this.businessEntrance = this.$route.query.businessEntrance
      } else {
        this.businessEntrance = ''
      }
      this.approval = this.$route.query.approval
      this.$request.get('/sys/commuser/userInfo').then((res) => {
        this.userId = res.user.userId
        if (this.$route.query.taskId !== undefined) {
          this.taskForm.id = this.$route.query.taskId
          this.getTaskInfo()
        }
      }).catch((err) => {
        console.log(err)
      })
      if (this.$route.query.processId) {
        this.getProcessInfo()
      }

      if(this.$route.query.type === 'register'){
        this.$refs.child.initialization();
      }
    })
  },
  created() {
    // 接收广播
    this.$eventHub.$on(this.GLOBAL.ACTIVATED_UPCOMING, (data) => {
      this.initialization()
    })
  },
  mounted() {
    this.initialization()
  },
  methods: {
    affirmatives(){
      this.affirmative = true
      this.approved(10)
    },
    click(){
      this.centerDialogVisible = false
    },
    initialization() {
      this.textarea = ''
      this.page = 1
    },
    myBrowser() {
      const userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
      if (userAgent.indexOf('OPR') > -1) {
          return 'Opera'
      }; // 判断是否Opera浏览器 OPR/43.0.2442.991
      if (userAgent.indexOf('Firefox') > -1) {
          return 'FF'
      } // 判断是否Firefox浏览器 Firefox/51.0
      if (userAgent.indexOf('Trident') > -1) {
          return 'IE'
      } // 判断是否IE浏览器  Trident/7.0; rv:11.0
      if (userAgent.indexOf('Edge') > -1) {
          return 'Edge'
      } // 判断是否Edge浏览器  Edge/14.14393
      if (userAgent.indexOf('Chrome') > -1) {
          return 'Chrome'
      } // Chrome/56.0.2924.87
      if (userAgent.indexOf('Safari') > -1) {
          return 'Safari'
      } // 判断是否Safari浏览器 AppleWebKit/534.57.2 Version/5.1.7 Safari/534.57.2
    },

    // 打开新页面 查看pdf简历. 可下载
    openResume() {
      //userid加密
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = '';
      if(this.$refs.child.dataForm.userId === ''){
        userId = '';
      }else {
        userId = base64url.encode(aes.encrypt(this.$refs.child.dataForm.userId + ''))
      }
      console.info("userId------"+userId)

      this.$router.push({
        name: 'acdc-resume-resumePDF',
        query: {
          export: this.$refs.child.dataForm.userId,
          userId: userId,
          recruitmentId: this.recruitmentId,
          userName: this.$refs.child.dataForm.userName,
          orgName: this.dealerName,
          jobName: this.positionNameCn,
          isAssessment: '1'
        }
      })
    },

    // 在线测评附件下载
    expertEvaluationDow() {
      this.$request.downloadLearning('/acdc/fileManagement/downloadFile',
        this.fileName,
        {
          recruitmentId: this.recruitmentId,
        },
        null,
        true
      )
    },

    getAssessmentReport() {
      // 取评估报告
      this.$request.get(
        `/sys/commuser/selectAssessmentReport`,
        {
          userId: this.$route.query.userId,
          type: this.$route.query.type,
          transferId:this.$route.query.transferId
        }
      ).then((res, total, code, data) => {
        if (res != null) {
          this.fileName = res.fileName
          this.recruitmentId = res.recruitmentId
          this.dealerName = res.dealerName
          this.positionNameCn = res.positionNameCn
        }

        //console.log('----------res----------:' + JSON.stringify(res))
      }).catch((err) => {
        console.log(err)
      })
    },
    // 撤回
    withdraw() {
      this.loading = true
      this.$request.post(
        '/sys/commuser/cancelPcRegister',
        {
          actOperate: {
            taskId: this.taskForm.taskId
          },
          commUser: {
            userId: this.$refs.child.dataForm.userId
          }
        }
      ).then((res, total, code, data) => {
        // 广播通知head-menu画面
        this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
        if (res && res.code + '' === '2') {
          this.$alert('该待办任务已被其他审批人审批完成').then(
            this.tabRemove(this.$store.state.contentTabsActiveName)
          )
          return false
        }
        this.$message({
          message: this.$t('activiti.withdrawSuccess'),
          showClose: true,
          duration: 1500,
          type: 'success'
        })
        this.loading = false
        this.tabRemove(this.$store.state.contentTabsActiveName)
      }).catch((err) => {
        console.log(err)
      })
    },

    // 审批
    approved(type) {
      //防止连续点击
      this.preventClick = true
      setTimeout(() => {
        this.preventClick = false
      }, 3000)
      this.loading = true
      let regex = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
      if (this.textarea.match(regex)) {
        this.$alert('不允许输入表情等特殊字符')
        this.loading = false
        return false
      }
      // 20220120 注册申请和转岗流程在区域经理审批节点审批通过时确认勾选项必须勾选
      if (this.taskForm.taskName.indexOf(this.$t('areaManager.name')) != -1 && (this.type === 'transfer' || this.type === 'register')  && !this.approvalConfirmChecked) {
        this.$message({
          message: this.$t('activiti.pleaseCheck'),
          showClose: true,
          duration: 1500,
          type: 'warning'
        })
        this.loading = false
        return false
      }
      if (this.type === 'register') { // 入职
        if (type === 10) { // 审批通过

          // this.$refs.child.$refs['dataForm'].validate((valid) => {
          if (this.userRole === 'hradminAudit') {
            // if (!valid) {
            //   this.$message({
            //     message: this.$t('validate.required'),
            //     showClose: true,
            //     duration: 1500,
            //     type: 'warning'
            //   })
            //   this.loading = false
            //   return false
            // }
            this.$refs.child.dataFormSubmitHandle()
            if (!this.$refs.child.canUpdate) {
              this.loading = false
              return false
            }
          } else if (this.userRole === 'areaAudit') {
            let dataForm = JSON.parse(JSON.stringify(this.$refs.child.dataForm))
            if (dataForm.orgType === '10') {
              this.$refs.child.dataFormSubmitHandle()
              if (!this.$refs.child.canUpdate) {
                this.loading = false
                return false
              }
            }
          }
          let postDataForm = JSON.parse(JSON.stringify(this.$refs.child.dataForm))
          postDataForm.bmwSeniority = ''
          if (postDataForm.roleId !== '' && postDataForm.roleId !== null && postDataForm.roleId !== undefined && postDataForm.roleId instanceof Array) {
            postDataForm.roleId = postDataForm.roleId.join(',')
          }
          if (postDataForm.orgType === '50') {
            postDataForm.orgType = '60'
          }
          // 如果有历史版本不更新bmwJoinDate
          // 加入宝马时间等于加入当前公司日期，如果没有bmwJoinDate则赋值，如果有不做处理
          if (postDataForm.orgJoinDate && (!postDataForm.bmwJoinDate || postDataForm.bmwJoinDate === '')) {
            postDataForm.bmwJoinDate = postDataForm.orgJoinDate
          }
          let taApprovalFlag = '20'
          if (this.$refs.child.refsForm.taApprovalFlag === '10' || this.$refs.child.refsForm.taApprovalFlagOne === '10' || this.$refs.child.refsForm.taApprovalFlagTwo === '10') {
            taApprovalFlag = '10'
          }
          this.$request.post(
            '/sys/commuser/updateActUser',
            {
              actOperate: {
                checkSomeMobileFlag: this.affirmative,
                taskId: this.taskForm.taskId,
                userId: this.userId,
                comment: this.$t('activiti.agree') + '-' + this.textarea,
                variables: {
                  taApprovalFlag: taApprovalFlag,
                  auditStatus: 1
                }
              },
              commUser: postDataForm
            }
          ).then((res, total, code, data) => {
            // 广播通知head-menu画面
            this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
            if (res.code + '' === '2') {
              this.$alert('该待办任务已被其他审批人审批完成').then(
                this.tabRemove(this.$store.state.contentTabsActiveName)
              )
              return false
            }
            if (res.processStatus === 'complete') {
              this.$message({
                message: this.$t('activiti.registrationCompleteOver'),
                showClose: true,
                duration: 1500,
                type: 'success'
              })
              // this.updateFirstLogin()

            } else if (res.processStatus === 'running') {
              this.$message({
                message: this.$t('activiti.registrationRunning'),
                showClose: true,
                duration: 1500,
                type: 'success'
              })
            }
            if (res.processStatus === 'mobilecheckfailure') {
              this.centerDialogVisible = true;
              this.loading = false
              this.UserNames = res.userCode
              this.UsersPhone = res.mobile
            } else {
              this.loading = false
              this.tabRemove(this.$store.state.contentTabsActiveName)
            }
          }).catch((err) => {
            console.log(err)
          })
          // })
        } else if (type === 20) { // 审批拒绝
          if (this.textarea === '' || this.textarea === null) {
            this.$message({
              message: this.$t('validate.taskApproved'),
              showClose: true,
              duration: 1500,
              type: 'warning'
            })
            this.loading = false
            return false
          }
          let postDataForm = JSON.parse(JSON.stringify(this.$refs.child.oldDataForm))
          postDataForm.bmwSeniority = ''
          if (this.userRole === 'hradminAudit') {
            if (postDataForm.orgType === '60' && postDataForm.parentOrgId && postDataForm.parentOrgId !== '') {
              // 第二步打回用户，改变组织类型和所属公司为了APP端回显
              postDataForm.orgType = 50
              postDataForm.orgId = postDataForm.parentOrgId
            }
            // 打回到用户删除所有相关信息
            postDataForm.bmwJoinDate = ''
            postDataForm.brandCode = ''
            postDataForm.bbaNo = ''
            postDataForm.nscNo = ''
            postDataForm.authType = ''
            postDataForm.roleId = ''
            postDataForm.orgJoinDate = ''
            postDataForm.jobLevel = ''
            postDataForm.jobcodeAge = ''
            postDataForm.jobCode = ''
            postDataForm.jobcodeJoinDate = ''
            postDataForm.partTimeOutletOne = ''
            postDataForm.partTimeJobcodeOne = ''
            postDataForm.jobcodeJoinDateOne = ''
            postDataForm.partTimeOutletTwo = ''
            postDataForm.partTimeJobcodeTwo = ''
            postDataForm.jobcodeJoinDateTwo = ''
            postDataForm.bmwDeptCode = ''
            postDataForm.dealerShipId = ''
            postDataForm.officialAccountFlag = ''
            postDataForm.enterSchoolDate = ''
            postDataForm.leaveSchoolDate = ''
            postDataForm.graduateStatus = ''
          }
          if (postDataForm.roleId !== '' && postDataForm.roleId !== null && postDataForm.roleId !== undefined && postDataForm.roleId instanceof Array) {
            postDataForm.roleId = postDataForm.roleId.join(',')
          }
          this.$request.post(
            '/sys/commuser/updateActUser',
            {
              actOperate: {
                checkSomeMobileFlag: this.affirmative,
                taskId: this.taskForm.taskId,
                userId: this.userId,
                comment: this.$t('activiti.disagree') + '-' + this.textarea,
                variables: {
                  auditStatus: 0
                }
              },
              commUser: postDataForm
            }
          ).then((res, total, code, data) => {
            // 广播通知head-menu画面
            this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
            if (res.code + '' === '2') {
              this.$alert('该待办任务已被其他审批人审批完成').then(
                this.tabRemove(this.$store.state.contentTabsActiveName)
              )
              return false
            }
            this.$message({
              message: this.$t('activiti.registrationComplete'),
              type: 'success',
              showClose: true,
              duration: 1500
            })
            // this.updateFirstLogin()
            this.loading = false
            this.tabRemove(this.$store.state.contentTabsActiveName)
          }).catch((err) => {
            console.log(err)
          })
        }
      } else if (this.type === 'dimission') { // 离职
        this.$refs.child.dataFormSubmitHandle()
        if (!this.$refs.child.canUpdate) {
          this.loading = false
          return false
        }
        if (type === 10) { // 审批通过
          let dismissionForm = this.$refs.child.dismissionForm
          dismissionForm.dimissionStatus = '20'
          this.$request.post(
            '/sys/dimission/updateActDimission',
            {
              actOperate: {
                taskId: this.taskForm.taskId,
                userId: this.userId,
                comment: this.$t('activiti.agree') + '-' + this.textarea,
                variables: {
                  auditStatus: 1
                }
              },
              commUserDimission: dismissionForm
            }
          ).then((res, total, code, data) => {
            // 广播通知head-menu画面
            this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
            if (res.code + '' === '2') {
              this.$alert('该待办任务已被其他审批人审批完成').then(
                this.tabRemove(this.$store.state.contentTabsActiveName)
              )
              return false
            }
            this.$message({
              message: this.$t('activiti.registrationComplete'),
              showClose: true,
              duration: 1500,
              type: 'success'
            })
            this.loading = false
            this.tabRemove(this.$store.state.contentTabsActiveName)
          }).catch((err) => {
            console.log(err)
          })
        }
      } else if (this.type === 'transfer') { // 转岗
        if (type === 10) { // 审批通过

          let transferForm = this.$refs.child.transferForm
          transferForm.transferStatus = '20'
          if (this.userRole === 'taAudit') {
          this.$request.post(
            '/sys/position/transfer/updateActTransfer',
            {
              actOperate: {
                taskId: this.taskForm.taskId,
                userId: this.userId,
                comment: this.$t('activiti.agree') + '-' + this.textarea,
                variables: {
                    auditStatus: 1,
                    auditResultFlag: 10
                  }
                },
                commPositionTransfer: transferForm
              }
            ).then((res, total, code, data) => {
              // 广播通知head-menu画面
              this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
              if (res.code + '' === '2') {
                this.$alert('该待办任务已被其他审批人审批完成').then(
                  this.tabRemove(this.$store.state.contentTabsActiveName)
                )
                return false
              }
              this.$message({
                message: this.$t('activiti.registrationComplete'),
                showClose: true,
                duration: 1500,
                type: 'success'
              })
              this.loading = false
              this.tabRemove(this.$store.state.contentTabsActiveName)
            }).catch((err) => {
              console.log(err)
            })
          } else {
            this.$request.post(
              '/sys/position/transfer/updateActTransfer',
              {
                actOperate: {
                  taskId: this.taskForm.taskId,
                  userId: this.userId,
                  comment: this.$t('activiti.agree') + '-' + this.textarea,
                  variables: {
                    auditStatus: 1
                  }
                },
                commPositionTransfer: transferForm
              }
            ).then((res, total, code, data) => {
              // 广播通知head-menu画面
              this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
              if (res.code + '' === '2') {
                this.$alert('该待办任务已被其他审批人审批完成').then(
                  this.tabRemove(this.$store.state.contentTabsActiveName)
                )
                return false
              }
              this.$message({
                message: this.$t('activiti.registrationComplete'),
                showClose: true,
                duration: 1500,
                type: 'success'
              })
              this.loading = false
              this.tabRemove(this.$store.state.contentTabsActiveName)
            }).catch((err) => {
              console.log(err)
            })
          }

        } else if (type === 20) { // 审批拒绝
          if (this.textarea === '' || this.textarea === null) {
            this.$message({
              message: this.$t('validate.taskApproved'),
              showClose: true,
              duration: 1500,
              type: 'warning'
            })
            this.loading = false
            return false
          }
          let transferForm = this.$refs.child.transferForm
          transferForm.transferStatus = '40'
          if (this.userRole === 'taAudit') {
            this.$request.post(
              '/sys/position/transfer/updateActTransfer',
              {
                actOperate: {
                  taskId: this.taskForm.taskId,
                  userId: this.userId,
                  comment: this.$t('activiti.disagree') + '-' + this.textarea,
                  variables: {
                    auditStatus: 2, // 拒绝直接结束流程
                    auditResultFlag: 20
                  }
                },
                commPositionTransfer: transferForm
              }
            ).then((res, total, code, data) => {
              // 广播通知head-menu画面
              this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
              if (res.code + '' === '2') {
                this.$alert('该待办任务已被其他审批人审批完成').then(
                  this.tabRemove(this.$store.state.contentTabsActiveName)
                )
                return false
              }
              this.$message({
                message: this.$t('activiti.registrationComplete'),
                type: 'success',
                showClose: true,
                duration: 1500
              })
              this.loading = false
              this.tabRemove(this.$store.state.contentTabsActiveName)
            }).catch((err) => {
              console.log(err)
            })
          } else {
            this.$request.post(
              '/sys/position/transfer/updateActTransfer',
              {
                actOperate: {
                  taskId: this.taskForm.taskId,
                  userId: this.userId,
                  comment: this.$t('activiti.disagree') + '-' + this.textarea,
                  variables: {
                    auditStatus: 2 // 拒绝直接结束流程
                  }
                },
                commPositionTransfer: transferForm
              }
            ).then((res, total, code, data) => {
              // 广播通知head-menu画面
              this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
              if (res.code + '' === '2') {
                this.$alert('该待办任务已被其他审批人审批完成').then(
                  this.tabRemove(this.$store.state.contentTabsActiveName)
                )
                return false
              }
              this.$message({
                message: this.$t('activiti.registrationComplete'),
                type: 'success',
                showClose: true,
                duration: 1500
              })
              this.loading = false
              this.tabRemove(this.$store.state.contentTabsActiveName)
            }).catch((err) => {
              console.log(err)
            })
          }

        }
      } else if (this.type === 'registerOffering') { // 排期审批
        //排期审批追加培训收费校验
        let dataForm = this.$refs.child.dataForm

        this.$request.post(`/learning/offeringregiste/info`,{registeId: dataForm.registeId}).then((res, total, code, data) => {
          dataForm.waitingListFlag = data.data.waitingListFlag
          dataForm.isFullStaffed = data.data.isFullStaffed

          if (type === 10) { // 审批通过
            if (dataForm.waitingListFlag === '20' && dataForm.isFullStaffed === '10') {
              this.loading = false
              this.$alert(this.$t('registerOffering.tips'))
              return false
            }
            //
            console.log(">>>>>>>>>>>>>姓名"+this.taskForm.variables.processStartUserCode)
            this.keepoff(dataForm,this.taskForm.variables.processStartUserCode)
            console.log(JSON.stringify(dataForm)+"######"+dataForm.offeringId+">>>>>>>>>>>>>>>>>>>"+this.userId)
            // let isJoin = 'N'
            // if (dataForm.waitingListFlag === '10' && dataForm.isFullStaffed === '10') {
            //   //20210325追加
            //   isJoin = 'Y'
            //   this.approveRegisterOfferingDeadline(dataForm, isJoin);
            // } else {
            //   this.approveRegisterOffering(dataForm, isJoin);
            // }
          } else if (type === 20) { // 审批拒绝
            if (this.textarea === '' || this.textarea === null) {
              this.loading = false
              this.$message({
                message: this.$t('validate.taskApproved'),
                showClose: true,
                duration: 1500,
                type: 'warning'
              })
              return false
            }
            this.$request.post(
                    '/learning/offeringregiste/actAudit',
                    {
                      actOperate: {
                        taskId: this.taskForm.taskId,
                        userId: this.userId,
                        comment: this.$t('activiti.disagree') + '-' + this.textarea,
                        variables: {
                          auditStatus: 0
                        }
                      },
                      offeringRegisteDTO: dataForm
                    }
            ).then((res, total, code, data) => {
              // 广播通知head-menu画面
              this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
              if (res.code + '' === '2') {
                this.loading = false
                this.$alert('该待办任务已被其他审批人审批完成').then(
                        this.tabRemove(this.$store.state.contentTabsActiveName)
                )
                return false
              }
              this.$message({
                message: this.$t('activiti.registrationComplete'),
                type: 'success',
                showClose: true,
                duration: 1500
              })
              this.loading = false
              this.tabRemove(this.$store.state.contentTabsActiveName)
            }).catch(() => {
              this.loading = false
            })
          }
        }).catch(() => { })

      } else if (this.type === 'courseDemain') { // 开课审批
        let dataForm = this.$refs.child.dataForm
        if (type === 10) { // 审批通过
          this.$request.post(
            '/learning/offeringregiste/actAuditCourseDemandApply',
            {
              actOperate: {
                taskId: this.taskForm.taskId,
                userId: this.userId,
                comment: this.$t('activiti.agree') + '-' + this.textarea,
                variables: {
                  auditStatus: 1
                }
              },
              courseDemandApplyDTO: dataForm
            }
          ).then((res, total, code, data) => {
            if (data.code === -400) {
              this.loading = false
              this.$alert(data.msg)
              return false
            }
            // 广播通知head-menu画面
            this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
            if (res.code + '' === '2') {
              this.loading = false
              this.$alert('该待办任务已被其他审批人审批完成').then(
                this.tabRemove(this.$store.state.contentTabsActiveName)
              )
              return false
            }
            this.$message({
              message: this.$t('activiti.registrationComplete'),
              showClose: true,
              duration: 1500,
              type: 'success'
            })
            this.loading = false
            this.tabRemove(this.$store.state.contentTabsActiveName)
          }).catch(() => {
            this.loading = false
          })
        } else if (type === 20) { // 审批拒绝
          if (this.textarea === '' || this.textarea === null) {
            this.loading = false
            this.$message({
              message: this.$t('validate.taskApproved'),
              showClose: true,
              duration: 1500,
              type: 'warning'
            })
            return false
          }
          this.$request.post(
            '/learning/offeringregiste/actAuditCourseDemandApply',
            {
              actOperate: {
                taskId: this.taskForm.taskId,
                userId: this.userId,
                comment: this.$t('activiti.disagree') + '-' + this.textarea,
                variables: {
                  auditStatus: 0
                }
              },
              courseDemandApplyDTO: dataForm
            }
          ).then((res, total, code, data) => {
            // 广播通知head-menu画面
            this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
            if (res.code + '' === '2') {
              this.loading = false
              this.$alert('该待办任务已被其他审批人审批完成').then(
                this.tabRemove(this.$store.state.contentTabsActiveName)
              )
              return false
            }
            this.$message({
              message: this.$t('activiti.registrationComplete'),
              type: 'success',
              showClose: true,
              duration: 1500
            })
            this.loading = false
            this.tabRemove(this.$store.state.contentTabsActiveName)
          }).catch(() => {
            this.loading = false
          })
        }
      } else if (this.type === 'authApproval') {
        if (type === 10) { // 审批通过
          const base64url = require('base64-url')
          let aes = new AesUtil()
          let userId = base64url.encode(aes.encrypt(this.$refs.child.dataForm.userId + ''))
          // 检查经销商最大数
          this.$request.get('/sys/commAuthApply/checkDealerAdminCountMT',
              {
                userId: userId,
                targetAuthType: this.$refs.child.dataForm.targetAuthType,
                targetRoleIds: this.$refs.child.dataForm.targetRoleIds
              }
           ).then((res) => {
                if (res === '10') {
                  this.loading = false
                  this.$alert('该经销商管理员数量已达到最大，无法赋予该角色')
                  return false
                } else {
                    let temporaryForm = {}
                    temporaryForm.authId = this.$refs.child.dataForm.authId
                    temporaryForm.userId = this.$refs.child.dataForm.userId
                    temporaryForm.approvalStatus = '20'
                    temporaryForm.targetAuthType = this.$refs.child.dataForm.targetAuthType
                    temporaryForm.targetRoleIds = this.$refs.child.dataForm.targetRoleIds
                    temporaryForm.fileManagementId = this.$refs.child.dataForm.fileManagementId
                    this.$request.post(
                      '/sys/commAuthApply/updateAuthApproval',
                      {
                        actOperate: {
                          taskId: this.taskForm.taskId,
                          userId: this.userId,
                          comment: this.$t('activiti.agree') + '-' + this.textarea,
                          variables: {
                            auditStatus: 1
                          }
                        },
                        approvalForm: temporaryForm
                      }
                    ).then((res, total, code, data) => {
                      // 广播通知head-menu画面
                      this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
                      if (res.code + '' === '2') {
                        this.$alert('该待办任务已被其他审批人审批完成').then(
                          this.tabRemove(this.$store.state.contentTabsActiveName)
                        )
                        return false
                      }
                      this.$message({
                        message: this.$t('activiti.registrationComplete'),
                        showClose: true,
                        duration: 1500,
                        type: 'success'
                      })
                      this.loading = false
                      this.tabRemove(this.$store.state.contentTabsActiveName)
                    }).catch((err) => {
                      console.log(err)
                    })
                }
        }).catch((err) => {
          console.log(err)
        })

          // let temporaryForm = {}
          // temporaryForm.authId = this.$refs.child.dataForm.authId
          // temporaryForm.userId = this.$refs.child.dataForm.userId
          // temporaryForm.approvalStatus = '20'
          // temporaryForm.targetAuthType = this.$refs.child.dataForm.targetAuthType
          // temporaryForm.targetRoleIds = this.$refs.child.dataForm.targetRoleIds
          // temporaryForm.fileManagementId = this.$refs.child.dataForm.fileManagementId
          // this.$request.post(
          //   '/sys/commAuthApply/updateAuthApproval',
          //   {
          //     actOperate: {
          //       taskId: this.taskForm.taskId,
          //       userId: this.userId,
          //       comment: this.$t('activiti.agree') + '-' + this.textarea,
          //       variables: {
          //         auditStatus: 1
          //       }
          //     },
          //     approvalForm: temporaryForm
          //   }
          // ).then((res, total, code, data) => {
          //   // 广播通知head-menu画面
          //   this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
          //   if (res.code + '' === '2') {
          //     this.$alert('该待办任务已被其他审批人审批完成').then(
          //       this.tabRemove(this.$store.state.contentTabsActiveName)
          //     )
          //     return false
          //   }
          //   if (res.code + '' === '3') {
          //       alert('审批通过接受了')
          //       this.loading = false
          //       return false
          //     }

          //   this.$message({
          //     message: this.$t('activiti.registrationComplete'),
          //     showClose: true,
          //     duration: 1500,
          //     type: 'success'
          //   })
          //   this.loading = false
          //   this.tabRemove(this.$store.state.contentTabsActiveName)
          // }).catch(() => { })
        } else if (type === 20) { // 审批拒绝
          if (this.textarea === '' || this.textarea === null) {
            this.$message({
              message: this.$t('validate.taskApproved'),
              showClose: true,
              duration: 1500,
              type: 'warning'
            })
            this.loading = false
            return false
          }
          let temporaryForm = {}
          temporaryForm.authId = this.$refs.child.dataForm.authId
          temporaryForm.approvalStatus = '40'
          temporaryForm.fileManagementId = this.$refs.child.dataForm.fileManagementId

          temporaryForm.userId = this.$refs.child.dataForm.userId
          temporaryForm.targetAuthType = this.$refs.child.dataForm.targetAuthType
          temporaryForm.targetRoleIds = this.$refs.child.dataForm.targetRoleIds


          this.$request.post(
            '/sys/commAuthApply/updateAuthApproval',
            {
              actOperate: {
                taskId: this.taskForm.taskId,
                userId: this.userId,
                comment: this.$t('activiti.disagree') + '-' + this.textarea,
                variables: {
                  auditStatus: 2 // 拒绝直接结束流程
                }
              },
              approvalForm: temporaryForm
            }
          ).then((res, total, code, data) => {
            // 广播通知head-menu画面
            this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
            if (res.code + '' === '2') {
              this.$alert('该待办任务已被其他审批人审批完成').then(
                this.tabRemove(this.$store.state.contentTabsActiveName)
              )
              return false
            }
            this.$message({
              message: this.$t('activiti.registrationComplete'),
              type: 'success',
              showClose: true,
              duration: 1500
            })
            this.loading = false
            this.tabRemove(this.$store.state.contentTabsActiveName)
          }).catch((err) => {
            console.log(err)
          })
        }
      }
    },
      approveRegisterOffering(dataForm, isJoin) {
      this.$request.post(
        '/learning/offeringregiste/actAudit',
        {
          actOperate: {
            taskId: this.taskForm.taskId,
            userId: this.userId,
            comment: this.$t('activiti.agree') + '-' + this.textarea,
            variables: {
              auditStatus: 1
            }
          },
          offeringRegisteDTO: dataForm,
          isJoin: isJoin
        }
      ).then((res, total, code, data) => {
          if (data.msg == '账户余额不足，请及时预存资金。') {
              this.loading = false
              this.dataListLoading=false
              this.$message({
                  message: '账户余额不足，请及时预存资金',
                  type: 'error'
              })
              return false
          }
        if (data.msg == '用户前提课未完成') {
          this.loading = false
          this.dataListLoading=false
          this.$message({
            message: '用户前提课未完成',
            type: 'error'
          })
          return false
        }
        if (data.code == -400) {
          this.loading = false
          this.dataListLoading=false
          this.$message({
            message: data.msg,
            type: 'error'
          })
          return false
        }
        if (data.msg == '当前用户等同课程已完成,是否继续报名') {
          this.$confirm(data.msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$request.post(
                    '/learning/offeringregiste/actAudit',
                    {
                      actOperate: {
                        taskId: this.taskForm.taskId,
                        userId: this.userId,
                        comment: this.$t('activiti.agree') + '-' + this.textarea,
                        variables: {
                          auditStatus: 1
                        }
                      },
                      offeringRegisteDTO: dataForm,
                      isJoin: isJoin,
                      isTrue: 'true'
                    }
            ).then((res, total, code, data) => {
              if (data.msg == '账户余额不足，请及时预存资金。') {
                this.loading = false
                this.dataListLoading=false
                this.$message({
                  message: '账户余额不足，请及时预存资金',
                  type: 'error'
                })
                return false
              }
              if (data.msg == '用户前提课未完成') {
                this.loading = false
                this.dataListLoading=false
                this.$message({
                  message: '用户前提课未完成',
                  type: 'error'
                })
                return false
              }
              if (data.code == -400) {
                this.loading = false
                this.dataListLoading=false
                this.$message({
                  message: data.msg,
                  type: 'error'
                })
                return false
              }
              if (data.code != 1) {
                this.loading = false
                this.dataListLoading=false
                this.$alert(data.msg)
                return false
              }
              if (data.msg === "已报名该时段的其他排期，由于时间冲突，操作失败。冲突排期如下"){
                this.$refs.selectVehicleinfo.selection.forEach(function (
                        item,
                        index,
                        arr
                ) {
                  console.info("******", item);
//                  if (item === row) {
//                    arr.splice(index, 1);
//                  }
                });
                this.dataListLoading = false;
                this.dialogVisible1 = true
                console.log(data.data["errData"])
                this.errorData =  data.data["errData"]
              }
              // 广播通知head-menu画面
              this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
              if (res.code + '' === '2') {
                this.loading = false
                this.dataListLoading=false
                this.$alert('该待办任务已被其他审批人审批完成').then(
                        this.tabRemove(this.$store.state.contentTabsActiveName)
                )
                return false
              }
              this.$message({
                message: this.$t('activiti.registrationComplete'),
                showClose: true,
                duration: 1500,
                type: 'success'
              })
              this.loading = false
              this.dataListLoading=false
              this.tabRemove(this.$store.state.contentTabsActiveName)
            }).catch(() => {
              this.loading = false
              this.dataListLoading=false
            })
          }).catch(() => {
            this.loading = false
            this.dataListLoading=false
            return false
          });
        }
        if (data.code != 1) {
          this.loading = false
          this.dataListLoading=false
          this.$alert(data.msg)
          return false
        }
        if (data.msg === "已报名该时段的其他排期，由于时间冲突，操作失败。冲突排期如下"){
          this.$refs.selectVehicleinfo.selection.forEach(function (
                  item,
                  index,
                  arr
          ) {
            console.info("******", item);
//            if (item === row) {
//              arr.splice(index, 1);
//            }
          });
          this.dataListLoading = false;
          this.dialogVisible1 = true
          console.log(data.data["errData"])
          this.errorData =  data.data["errData"]
        }
        // 广播通知head-menu画面
        this.$eventHub.$emit(this.GLOBAL.TODO_TASK, '')
        if (res.code + '' === '2') {
          this.loading = false
          this.dataListLoading=false
          this.$alert('该待办任务已被其他审批人审批完成').then(
            this.tabRemove(this.$store.state.contentTabsActiveName)
          )
          return false
        }
        this.$message({
          message: this.$t('activiti.registrationComplete'),
          showClose: true,
          duration: 1500,
          type: 'success'
        })
        this.loading = false
        this.dataListLoading=false
        this.tabRemove(this.$store.state.contentTabsActiveName)
      }).catch(() => {
        this.loading = false
          this.dataListLoading=false
      })
    },
    approveRegisterOfferingDeadline(dataForm, isJoin) {
      this.$request.post(
              '/learning/offeringregiste/actAuditDeadline',
              {
                actOperate: {
                  taskId: this.taskForm.taskId,
                  userId: this.userId,
                  comment: this.$t('activiti.agree') + '-' + this.textarea,
                  variables: {
                    auditStatus: 1
                  }
                },
                offeringRegisteDTO: dataForm,
                isJoin: isJoin
              }
      ).then((res, total, code, data) => {
        if (data.code != 1) {
          this.loading = false
          this.dataListLoading=false
          this.$alert(data.msg)
          var tet=false
          return false
        }
        this.$confirm(this.$t('registerOffering.isJoinWaitingList'), {
          confirmButtonText: this.$t('registerOffering.join'),
          cancelButtonText: this.$t('registerOffering.cancel'),
          type: 'warning'
        }).then(() => {
          // 加入等候名单
          isJoin = 'Y'
          this.approveRegisterOffering(dataForm, isJoin);
        }).catch(() => {
          this.loading = false
          this.dataListLoading=false
          // 取消加入等候名单
          // this.approveRegisterOffering(dataForm,isJoin);
        })
        return true

      }).catch(() => {
        return false
      })
    },
    // 追加是否免费校验
    approvefreeruleschecke(dataForm, isJoin) {
      this.$request.post(
              '/learning/rule/freerules/check',
              {
                  offeringId: dataForm.offeringId,
                  userId: this.userId,
              }
      ).then((res, total, code, data) => {
        if (data.code != 1) {
          this.loading = false
          this.$alert(data.msg)
          var tet=false
          return false
        }
        this.$confirm(this.$t('registerOffering.isJoinWaitingList'), {
          confirmButtonText: this.$t('registerOffering.join'),
          cancelButtonText: this.$t('registerOffering.cancel'),
          type: 'warning'
        }).then(() => {
          // 加入等候名单
          let tmpIsJoin = 'Y'
          this.approveRegisterOffering(dataForm, tmpIsJoin);
        }).catch(() => {
          this.loading = false
          // 取消加入等候名单
          // this.approveRegisterOffering(dataForm,isJoin);
        })
        return true

      }).catch(() => {
        return false
      })
    },
    keepoff1 (dataForm,userCode) {
      let isDeduction=this.$refs.child.isDeduction
      let isDealer=false//this.$refs.child.isDealer
      let accountBalance=this.$refs.child.accountBalance
      let deduction=dataForm.coursePrice //扣款金额
      let coms=''
      let cousrprice=dataForm.coursePrice
      if(isDeduction){ //减免
        coms='<br/><td>'+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;减免金额："+this.formatMoney(Number ((dataForm.coursePrice).toFixed(3)))+"</td>"
          cousrprice=0
      }
        let accountBalances=this.$refs.child.accountBalance
      console.log(">>>>>>>>>>>>"+cousrprice)
      /// 付费后可用余额
        let comsh="<br/>"
      if(Number(Number(accountBalances)-Number(cousrprice))>=0){
          comsh='<br/><td style="margin-bottom:10px;">'+"付费后可用余额："+this.formatMoney(Number (((accountBalances-cousrprice)).toFixed(3)))+"</td>"
      }
      console.log((accountBalances-cousrprice)+">>>>>>>>>>>>"+Number(Number(accountBalances)-Number(cousrprice)))
      let mesg = ("<div style='margin:10px 0 0 100px;'> <td style=\"margin-bottom:10px;\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;申请人：" + userCode+'</td>'//text-align:center;
              +'<br/><td style="margin-bottom:10px;">'+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;排期价格："+this.formatMoney(Number ((dataForm.coursePrice).toFixed(3)))+'</td>'
              +'<br/><td style="margin-bottom:10px;">'+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;可用余额："+this.formatMoney(Number ((accountBalances).toFixed(3)))+'</td>'
              +coms
              +'<br/><td style="margin-bottom:10px;">'+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;支付金额："+this.formatMoney(Number ((cousrprice).toFixed(3)))+'</td>'
              +comsh+
          "</div>")
      console.log(Number(Number(accountBalances)-Number(cousrprice))+comsh+">>>>>>>"+mesg)
      dataForm.isDeduction=isDeduction
      this.$confirm(mesg, this.$t('prompt.titleprice'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(() => {
        if(!isDealer){//不是经销商时
          deduction=0
        }
        let cout=(accountBalance-deduction)
        console.info(">>>>>>>>账户剩余金额"+cout)
        if(cout>=0){
          console.info(">>>>>>>>余额充足")
          let isJoin = 'N'
          if (dataForm.waitingListFlag === '10' && dataForm.isFullStaffed === '10') {
            //20210325追加
            isJoin = 'Y'
            this.approveRegisterOfferingDeadline(dataForm, isJoin);
          } else {
            this.approveRegisterOffering(dataForm, isJoin);
          }
        }else{
          console.info(">>>>>>>>账户余额不足")
          this.$message({
            message: '账户余额不足，请及时预存资金',
            type: 'error'
          })
          this.loading = false
        }

      }).catch(() => {
        this.loading = false
      })
    },
    keepoff (dataForm,userCode) {
      this.dataForm = dataForm
      console.log(this.dataForm)
      this.userCode = userCode;
      this.isDeduction=this.$refs.child.isDeduction
      this.isDealer=false//this.$refs.child.isDealer
      this.accountBalance=this.$refs.child.accountBalance
      this.deduction=dataForm.coursePrice //扣款金额
      this.coms=''
      this.cousrprice=dataForm.coursePrice
      if(this.isDeduction){ //减免
        this.coms='<br/><td>'+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;减免金额："+this.formatMoney(Number ((dataForm.coursePrice).toFixed(3)))+"</td>"
        this.cousrprice=0
      }
      this.accountBalances=this.$refs.child.accountBalance
      console.log(">>>>>>>>>>>>"+this.cousrprice)
      /// 付费后可用余额
      this.comsh="<br/>"
      if(Number(Number(this.accountBalances)-Number(this.cousrprice))>=0){
        this.comsh='<br/><td style="margin-bottom:10px;">'+"付费后可用余额："+this.formatMoney(Number (((this.accountBalances-this.cousrprice)).toFixed(3)))+"</td>"
      }
      console.log((this.accountBalances-this.cousrprice)+">>>>>>>>>>>>"+Number(Number(this.accountBalances)-Number(this.cousrprice)))
      this.mesg = ("<div style='margin:10px 0 0 100px;'> <td style=\"margin-bottom:10px;\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;申请人：" + userCode+'</td>'//text-align:center;
              +'<br/><td style="margin-bottom:10px;">'+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;排期价格："+this.formatMoney(Number ((dataForm.coursePrice).toFixed(3)))+'</td>'
              +'<br/><td style="margin-bottom:10px;">'+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;可用余额："+this.formatMoney(Number ((this.accountBalances).toFixed(3)))+'</td>'
              +this.coms
              +'<br/><td style="margin-bottom:10px;">'+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;支付金额："+this.formatMoney(Number ((this.cousrprice).toFixed(3)))+'</td>'
              +this.comsh+
              "</div>")
      console.log(Number(Number(this.accountBalances)-Number(this.cousrprice))+this.comsh+">>>>>>>"+this.mesg)
      dataForm.isDeduction=this.isDeduction
      this.discountDialog = true;
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>")
      return false;
      /* this.$confirm(this.mesg, this.$t('prompt.titleprice'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(() => {
        if(!this.isDealer){//不是经销商时
          this.deduction=0
        }
        this.cout=(this.accountBalance-this.deduction)
        console.info(">>>>>>>>账户剩余金额"+this.cout)
        if(this.cout>=0){
          console.info(">>>>>>>>余额充足")
          this.isJoin = 'N'
          if (this.dataForm.waitingListFlag === '10' && this.dataForm.isFullStaffed === '10') {
            //20210325追加
            this.isJoin = 'Y'
            this.approveRegisterOfferingDeadline(dataForm, this.isJoin);
          } else {
            this.approveRegisterOffering(dataForm, this.isJoin);
          }
        }else{
          console.info(">>>>>>>>账户余额不足")
          this.$message({
            message: '账户余额不足，请及时预存资金',
            type: 'error'
          })
          this.loading = false
        }

      }).catch(() => {
        this.loading = false
      }); */
    },
    cancelForm(){
      this.discountDialog = false;
      this.loading = false;
    },
    submitForm(dataForm,userCode){
      this.$request.post(`/learning/offeringregiste/info`,{registeId: this.dataForm.registeId}).then((res, total, code, data) => {
        this.dataForm.waitingListFlag = data.data.waitingListFlag
        this.dataForm.isFullStaffed = data.data.isFullStaffed

        this.dataListLoading = true
        if(!this.isDealer){//不是经销商时
          this.deduction=0
        }
        this.cout=(this.accountBalance-this.deduction)
        if(this.cout>=0){
          console.info(">>>>>>>>余额充足")
          this.isJoin = 'N'
          if (this.dataForm.waitingListFlag === '10' && this.dataForm.isFullStaffed === '10') {
            //20210325追加
            this.isJoin = 'Y'
            this.approveRegisterOfferingDeadline(this.dataForm, this.isJoin);
          } else if (this.dataForm.waitingListFlag === '20' && this.dataForm.isFullStaffed === '10') {
            this.isJoin = 'N'
            this.loading = false
            this.dataListLoading = false
            this.$alert(this.$t('registerOffering.tips'))
            return false
          } else {
            this.approveRegisterOffering(this.dataForm, this.isJoin);
          }
        }else{
          console.info(">>>>>>>>账户余额不足")
          this.$message({
            message: '账户余额不足，请及时预存资金',
            type: 'error'
          })
          this.dataListLoading = false
          this.loading = false
        }
      }).catch(() => { })
    },

    prossTask(row) {
      return row.processInstanceName + '-' + row.taskName
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.page = 1
      this.limit = val
      this.getProcessInfo()
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.page = val
      this.getProcessInfo()
    },
    getProcessInfo() {
      this.$request.getAct(
        '/act/operate/historyByProcessId',
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          processId: this.$route.query.processId
        }
      ).then((res, total, code, data) => {
        let resList = data.result
        for (let i = 0; i < resList.length; i++) {
          let commentList = []
          if (resList[i].comment && resList[i].comment !== 'no comment') {
            commentList = resList[i].comment.split('-')
            resList[i].commentStatus = commentList[0]
            commentList.shift()
            resList[i].commentValue = commentList.join('-')
          }
        }
        this.processForm = resList
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? total : 0
      }).catch((err) => {
        console.log(err)
      })
    },
    getTaskInfo() {
      // 待办
      if (this.approval === 1 || this.approval === '1') {
        const base64url = require('base64-url')
        let aes = new AesUtil()
        let userId = base64url.encode(aes.encrypt(this.userId + ''))
        this.$request.getAct(
          '/act/operate/taskInfoMT',
          {
            taskId: this.taskForm.id,
            userId: userId
          }
        ).then((res, total, code, data) => {
          if (res.taskNameCn.indexOf(this.$t('areaManager.name')) != -1) {
            this.isAreaManagerAudit = true
          } else {
            this.isAreaManagerAudit = false
          }

          if (res.taskNameCn.indexOf(this.$t('areaManager.name')) != -1 && (this.type === 'transfer' || this.type === 'register')) {
            // 取评估报告
            this.getAssessmentReport();
          }

          this.taskForm = {
            ...this.taskForm,
            ...res
          }
          this.getFactoryDesc()
        }).catch((err) => {
          console.log(err)
        })
        // 已办
      } else {
        this.$request.getAct(
          '/act/operate/historyTaskInfo',
          {
            taskId: this.taskForm.id
          }
        ).then((res, total, code, data) => {
          res.curAssigneeName = this.getStorage(this.GLOBAL.USER_DATA).userName
          this.taskForm = {
            ...this.taskForm,
            ...res
          }
          this.getFactoryDesc()
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    // 返回按钮
    backPage() {
      this.tabRemove(this.$store.state.contentTabsActiveName)
    },
    // 删除当前Tag页，返回待办列表
    tabRemove(tabName) {
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 从离职列表审批，返回离职列表
      if (this.businessEntrance && this.businessEntrance === 'dimission') {
        this.$router.push({
          name: 'sys-dimission'
        })
      } else if (this.dealAll === '1') {
        this.$router.push({
          name: 'activiti-task-all'
        })
      } else {
        this.$router.push({
          name: 'activiti-task-upcoming'
        })
      }
    },
    // 获取厂家备注
    getFactoryDesc() {
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = base64url.encode(aes.encrypt(this.userId + ''))
      // let userId = base64url.encode(aes.encrypt(this.$refs.child.dataForm.userId + ''))
      // console.log(JSON.parse(sessionStorage.getItem('v1user_data')), 'dfsfsdfd')
      const params = {
        userId: userId
      }
      this.$request.get('/acdc/restrict/userRemarkMT', params)
        .then((res) => {
          this.factoryDesc = res.remark
          this.factoryFile = res.fileName
        })
    },
    // 下载文件
    downloadFile () {
      const params = {
        fileName: this.factoryFile,
        businessKey: this.businessKey
      }
      const name = this.factoryFile.substring(0, this.factoryFile.indexOf('.pdf'))
      this.$request.downloadByPost2('/acdc/acdcCommon/downloadPDFWithWaterMark', name, params)
    },
      /**
       * 将数值四舍五入(保留2位小数)后格式化成金额形式
       *
       * @param num 数值(Number或者String)
       * @return 金额格式的字符串,如'1,234,567.45'
       * @type String
       */
      formatMoney(num) {
          if (!num && (num !== 0 && num !== '0')) {
              return ""
          }
          num = num.toString().replace(/\$|\,/g,'');
          if(isNaN(num)) {
              num = "0";
          }
          let sign = (num == (num = Math.abs(num)));
          num = Math.floor(num*100+0.50000000001);
          let cents = num%100;
          num = Math.floor(num/100).toString();
          if(cents<10) {
              cents = "0" + cents;
          }
          for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++) {
              num = num.substring(0,num.length-(4*i+3))+','+ num.substring(num.length-(4*i+3));
          }
          return (((sign)?'':'-') + num + '.' + cents);
      }
  }
}
</script>

<style scoped lang="scss">
.el-form-item__label {
  color: #999999 !important;
}
.row-mar-l {
  margin-left: 22px;
}
.disagree:hover {
  color: #606266;
  background-color: #fff !important;
  border-color: #dcdfe6;
}
.disagree.el-button.is-disabled:hover {
  color: #c0c4cc;
  background-color: #fff !important;
  border-color: #dcdfe6;
}
.disagreeClass {
  display: inline-block;
  padding-left: 15px;
}
.task-card-factory-desc {
  margin: 20px 0;
  padding: 20px 0 30px 20px;
  padding-right: 30%;
  border-top: 1px solid #EBEEF5;
  .el-textarea {
    margin-top: 0 !important;
  }
  .task-card-factory-desc-title {
    margin: 0;
    height: 26px;
    line-height: 26px;
    &.task-card-factory-desc-title2 {
      margin-top: 4px;
      color: #1C69D3;
      cursor: pointer;
      &:hover {
        opacity: .8;
      }
    }
  }
  .task-card-factory-desc-file {
    width: 19.8%;
  }
  .fl-input.is-disabled ::v-deep .el-input__inner {
    color: #1C69D3 !important;
    text-decoration:underline;
    cursor:pointer;
  }
  .fl-input:hover{
    opacity: .8;
  }
}
::v-deep .el-dialog__header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 24px;
.el-dialog__header_cus {
  height: 22px;
  line-height: 22px;
  color: rgba(37, 38, 40, 100);
  font-size: 16px;
  font-weight: bold;
  position: relative;
  padding-left: 11px;
  &::before {
   content: "";
   width: 3px;
   height: 14px;
   border-radius: 1px;
   display: inline-block;
   background-color: rgba(28, 105, 212, 1);
   position: absolute;
   top: 4px;
   left: 0px;
 }
}
}
::v-deep .el-dialog__body {
  padding: 24px !important;
}
.assign-dialog-tip {
  height: 18px;
  line-height: 18px;
  color: rgba(153, 154, 156, 100);
  font-size: 12px;
  text-align: left;
  font-family: PingFangSC-Regular, sans-serif;
  margin-bottom: 10px;
> span {
  color: #000;
}
}
/*}*/
::v-deep .show-msg-container {
  border-radius: 4px;
  background-color: rgba(232, 240, 250, 0.5);
  padding: 16px;
.msg-label {
  height: 22px;
  line-height: 22px;
  color: rgba(153, 154, 156, 100);
  font-size: 12px;
  text-align: right;
  font-family: PingFangSC-Regular, sans-serif;
}
.msg-value {
  height: 22px;
  line-height: 22px;
  color: rgba(37, 38, 40, 100);
  font-size: 14px;
  text-align: left;
  font-family: PingFangSC-Regular, sans-serif;
&.msg-spe-value{
   color: rgba(28, 105, 212, 100);
   font-family: PingFangSC-Semibold, sans-serif;
 }
}
}
.tag-reduction{
  text-align:center;
  display:inline-block;
  width: 36px;
  height: 18px;
  line-height:18px;
  color:rgb(28, 105, 212);
  border-radius: 2px;
  background-color: rgba(28, 105, 212, .1);
  font-family: PingFangSC-Regular, sans-serif;
}
  .addPointer {
    cursor: pointer;
    text-decoration: none;
  }
.disagree{
  background: #1C69D3 !important;
  color: #fff;
  z-index: 999;
}
.disagree.is-disabled{
  background: #ffffff !important;
  color:#888a8d;
  z-index: 999;
}
.disagree:hover{
  background: #1C69D3 !important;
  color: #fff;
  z-index: 999;

}
</style>
